import React, { useMemo } from 'react'
import Link from 'react-router-dom/Link'

import TextInput from '../../../../global/components/forms/TextInput.js.jsx'
import NumberInput from '../../../../global/components/forms/NumberInput.js.jsx'

const AdminOnboardForm = ({
  cancelLink,
  values,
  handleFormChange,
  handleFormSubmit,
  loading,
}) => {
  const isValid = useMemo(() => {
    return Object.values(values).every(value => !!value.toString().trim())
  }, [values])

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form
            name="firmForm"
            className="firm-form"
            onSubmit={handleFormSubmit}
          >
            <div className="formHeader">
              <h2>Create Firm</h2>
              <hr />
            </div>
            <TextInput
              change={handleFormChange}
              label="Name"
              name="name"
              placeholder="Name (required - maximum 150 characters)"
              required={true}
              value={values.name}
              minLength="3"
              maxLength="150"
            />
            <NumberInput
              change={handleFormChange}
              firefoxDisplayFix={true}
              min="1"
              label="License count (minimum 1)"
              name="licenseCount"
              required={true}
              step="1"
              value={values.licenseCount}
            />
            <TextInput
              change={handleFormChange}
              label="Owner First Name"
              name="contact_firstName"
              placeholder="First Name (required)"
              required={true}
              value={values.contact_firstName}
              maxLength="150"
            />
            <TextInput
              change={handleFormChange}
              label="Owner Last Name"
              name="contact_lastName"
              placeholder="Last Name (required)"
              required={true}
              value={values.contact_lastName}
              maxLength="150"
            />
            <TextInput
              change={handleFormChange}
              label="Owner Email Address"
              name="contact_email"
              placeholder="Email Address (required)"
              required={true}
              value={values.contact_email}
              maxLength="150"
            />
            <TextInput
              change={handleFormChange}
              label="Owner Phone Number"
              name="contact_phone"
              placeholder="Phone Number (required)"
              required={true}
              value={values.contact_phone}
              maxLength="150"
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <Link
                  className="yt-btn link"
                  to={cancelLink}
                >
                  Cancel
                </Link>
                <button
                  className="yt-btn"
                  disabled={!isValid || loading}
                  type="submit"
                >
                  {loading ? 'Creating...' : 'Create firm'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AdminOnboardForm
